import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    Grid,
    InputLabel,
    List,
    ListItem,
    makeStyles,
    MenuItem,
    Select,
    TextField,
    Typography,
    useMediaQuery,
    useTheme,
} from "@material-ui/core"
import { useCallback, useState } from "react"
import logo99 from "../../../assets/99-app-logo-0.png"
import { alertStart } from "../../../routes"
import { SalvarCardapio99Food } from "../../../services/99food"
import useLoadingStore from "../../../stores/LoadingStore"
import { useCardapioContext } from "./CardapioContext"
import Categorias from "./Categorias"
import DialogCategorias from "./DialogCategorias"
import DialogDuplicarGrupoDeOpcao from "./DialogDuplicarGrupoDeOpcao"
import DialogPassoDeMontagem from "./DialogPassoDeMontagem"
import DialogProdutos from "./DialogProdutos"
import DialogReordenar from "./DialogReordenar"

const useStyles = makeStyles(theme => ({
    container: {
        textAlign: "left",
        display: "flex",
        flexDirection: "column",
    },
    cabecalho: {
        position: "relative",
        display: "flex",
        flexWrap: "wrap",
        gap: "0.5rem",
        "& .container-opcoes-categorias": {
            display: "flex",
            flex: "1 1 100%",
            gap: "0.5rem",
            flexWrap: "wrap",
            [theme.breakpoints.up("md")]: {
                flex: "1 0 36rem",
            },
            "&>*": {
                flex: "1 1 auto",
                minWidth: "140px",
                [theme.breakpoints.down("sm")]: {
                    flex: "1 1 100%",
                },
            },
        },
        zIndex: 9,
        width: "100vw",
        backgroundColor: "white",
        padding: "0.8rem",
        borderBottom: "solid 1px rgba(0,0,0, 0.4)",
        [theme.breakpoints.up("md")]: {
            position: "fixed",
            top: "64px",
            left: "80px",
            width: "calc(100vw - 80px)",
            paddingRight: "1.2rem",
        },
        [theme.breakpoints.down("sm")]: {
            marginTop: "55px",
        },
    },
    botaoCadastrar: {
        backgroundColor: "red",
        color: "white",
        "&:hover": {
            backgroundColor: "#FF4D4D",
        },
    },
    botaoSalvar: {
        backgroundColor: "#14A44D",
        color: "white",
        "&:hover": {
            backgroundColor: "#28B76C",
        },
    },
    botaoSalvar99: {
        backgroundColor: "#FFD429",
        color: "white",
        "&:hover": {
            backgroundColor: "#FFD429",
        },
    },
    containerItens: {
        flexGrow: 1,
        [theme.breakpoints.up("md")]: {
            marginTop: "3.2rem",
        },
    },
    listItem: {
        paddingLeft: "0",
        paddingRight: "0",
    },
    botaoImprimir: {
        backgroundColor: "#007bff",
        color: "white",
        "&:hover": {
            backgroundColor: "#0056b3",
        },
    },
}))

export default function NovaTelaProdutos() {
    const theme = useTheme()
    const mobile = useMediaQuery(theme.breakpoints.down("sm"))
    const classes = useStyles()

    const setLoading = useLoadingStore(s => s.setLoading)

    const {
        estabelecimento,
        cardapio,
        categorias,
        setCategorias,
        insumos,
        cadastrar,
        setCadastrar,
        setSalvarCardapioCompleto,

        categoriaAtual,
        setCategoriaAtual,
        produtoAtual,
        setProdutoAtual,
        openCategoria,
        setOpenCategoria,
        openProduto,
        setOpenproduto,
        openPassoDeMontagem,
        setOpenPassoDeMontagem,
        modalCategoria,
        setModalCategoria,
        modalProduto,
        setModalProduto,
        modalPasso,
        setModalPasso,
        idPasso,
        openDuplicarGrupoDeMontagem,
        handleToggleDuplicarGrupoDeMontagem,

        insumoSelecionado,
        setInsumoSelecionado,
        insumosSelecionados,
        fichaTecnica,
        quantidades,
        setQuantidades,
        setAltInsumo,
        produto,

        handleSalvarCategoria,
        handleDuplicarCategoria,
        handleExcluirCategoria,
        handleSalvarProduto,
        handleDuplicarProduto,
        handleExcluirProduto,
        handleCadastrarGrupoDeOpcao,
        handleDuplicarPassoDeMontagem,
        handleExcluirGrupoDeOpcao,
        handleCadastrarOpcao,
        handleExcluirOpcao,
        handleIdsEditar,
        handleSalvarCardapioInteiro,
        handleCadastrarImagem,
        handleAddInsumo,
        handleDeleteInsumo,
        salvarFt,
        buscarFT,
        renderKey,
    } = useCardapioContext()

    const [valorPesquisa, setValorPesquisa] = useState("")
    const [draggingItem, setDraggingItem] = useState(null)
    const [openReordenar, setOpenReordenar] = useState(false)
    const [openConfirmacaoSalvar99, setOpenConfirmacaoSalvar99] = useState(false)
    const handleCloseConfirmacaoSalvar99 = () => setOpenConfirmacaoSalvar99(false)

    const salvarCardapio99 = async () => {
        setLoading(true)
        try {
            await SalvarCardapio99Food(cardapio)
            alertStart("Enviado para atualização!", "success")
            handleCloseConfirmacaoSalvar99()
        } catch (error) {
            console.error("Erro Salvar99", error.response)
            alertStart(error.response?.data, "error")
        } finally {
            setLoading(false)
        }
    }

    const handleClickOpenCategoria = () => setOpenCategoria(true)
    const handleCloseCategoria = () => setOpenCategoria(false)
    const handleCloseProduto = () => {
        setAltInsumo(false)
        setOpenproduto(false)
    }
    const handleChangeCategoria = useCallback(
        e => {
            if (!e.target.value) {
                setCategorias(cardapio.categorias)
            } else {
                setCategorias(
                    cardapio.categorias.filter(cat => cat.exibicaoCategoriaEnum === e.target.value)
                )
            }
        },
        [cardapio?.categorias, setCategorias]
    )

    const procurarProduto = useCallback(
        e => {
            setValorPesquisa(e.target.value.toLowerCase())
            setCategorias(
                cardapio.categorias.filter(busca =>
                    busca.nome.toLowerCase().includes(e.target.value.toLowerCase())
                )
            )
        },
        [cardapio?.categorias, setCategorias]
    )

    const handleDragOver = useCallback(
        index => {
            if (draggingItem === null) return
            if (draggingItem === index) return
            const itens = categorias.filter((_, idx) => idx !== draggingItem)
            itens.splice(index, 0, categorias[draggingItem])
            itens.forEach((item, idx) => {
                item.ordemExib = idx
            })
            setCategorias(itens)
            setDraggingItem(index)
        },
        [draggingItem, categorias, setCategorias]
    )

    return (
        <>
            <DialogReordenar open={openReordenar} onClose={() => setOpenReordenar(false)} />
            <DialogCategorias
                open={openCategoria}
                cadastrar={cadastrar}
                modalCategoria={modalCategoria}
                estabelecimento={estabelecimento}
                categorias={categorias}
                handleCloseCategoria={handleCloseCategoria}
                handleSalvarCategoria={handleSalvarCategoria}
            />
            <DialogProdutos
                open={openProduto}
                modalProduto={modalProduto}
                cadastrar={cadastrar}
                handleCloseProduto={handleCloseProduto}
                handleSalvarProduto={handleSalvarProduto}
                categorias={categorias}
                categoriaAtual={categoriaAtual}
                handleCadastrarImagem={handleCadastrarImagem}
                estabelecimento={estabelecimento}
                insumos={insumos}
                insumoSelecionado={insumoSelecionado}
                insumosSelecionados={insumosSelecionados}
                fichaTecnica={fichaTecnica}
                quantidades={quantidades}
                handleAddInsumo={handleAddInsumo}
                handleDeleteInsumo={handleDeleteInsumo}
                salvarFt={salvarFt}
                setInsumoSelecionado={setInsumoSelecionado}
                setQuantidades={setQuantidades}
                setAltInsumo={setAltInsumo}
                buscarFT={buscarFT}
                produto={produto}
            />
            <DialogPassoDeMontagem
                open={openPassoDeMontagem}
                setOpenPassoDeMontagem={setOpenPassoDeMontagem}
                modalPasso={modalPasso}
                cadastrar={cadastrar}
                handleCadastrarGrupoDeOpcao={handleCadastrarGrupoDeOpcao}
                produtoAtual={produtoAtual}
            />
            <DialogDuplicarGrupoDeOpcao
                open={openDuplicarGrupoDeMontagem}
                handleToggleDuplicarGrupoDeMontagem={handleToggleDuplicarGrupoDeMontagem}
                categorias={categorias}
                handleDuplicarPassoDeMontagem={handleDuplicarPassoDeMontagem}
                idPasso={idPasso}
            />
            <div
                className={classes.container}
                style={{
                    width: mobile ? "100vw" : "calc(100vw - 97px)",
                    padding: mobile ? "0" : "0px 16px",
                }}
            >
                <div className={classes.cabecalho}>
                    <div className="container-opcoes-categorias">
                        <Button
                            className={classes.botaoCadastrar}
                            onClick={() => {
                                handleClickOpenCategoria()
                                setCadastrar(true)
                                setModalCategoria(null)
                            }}
                        >
                            Cadastrar Categoria
                        </Button>
                        <FormControl size="small" variant="outlined">
                            <InputLabel>Tipo Categoria</InputLabel>
                            <Select
                                label="Tipo Categoria"
                                defaultValue={null}
                                onChange={handleChangeCategoria}
                                style={{ backgroundColor: "#fff" }}
                            >
                                <MenuItem value={null}>Todos</MenuItem>
                                <MenuItem value="DELIVERY">Delivery</MenuItem>
                                <MenuItem value="PEDIDO_MESA">Mesa</MenuItem>
                                <MenuItem value="REGISTRADOR">Estabelecimento</MenuItem>
                            </Select>
                        </FormControl>
                        <TextField
                            type="text"
                            variant="outlined"
                            label="Procurar Categoria"
                            placeholder="Buscar"
                            size="small"
                            InputLabelProps={{ shrink: true }}
                            onChange={procurarProduto}
                            value={valorPesquisa}
                            style={{ backgroundColor: "#fff", minWidth: "12rem" }}
                        />
                    </div>
                    <div
                        style={{
                            display: "flex",
                            flexWrap: "wrap",
                            gap: "0.5rem",
                            justifyContent: mobile ? "stretch" : "flex-end",
                            flex: mobile ? "1 1 100%" : "1 0 36rem",
                        }}
                    >
                        <div
                            style={{
                                display: "flex",
                                gap: "0.5rem",
                                flex: mobile ? "1 1 100%" : "0 1 auto",
                            }}
                        >
                            <Button
                                className={classes.botaoImprimir}
                                onClick={() => setOpenReordenar(true)}
                                variant="outlined"
                                style={{ flex: mobile ? "1" : "0 1 auto" }}
                            >
                                Reordenar
                            </Button>
                            <Button
                                onClick={handleSalvarCardapioInteiro}
                                className={classes.botaoSalvar}
                                style={{ flex: mobile ? "1" : "0 1 auto" }}
                            >
                                Salvar
                            </Button>
                            <Button
                                    onClick={() => setOpenConfirmacaoSalvar99(true)}
                                    className={classes.botaoSalvar99}
                                    endIcon={<img src={logo99} alt="" height={20} width={20} />}
                                    style={{ flex: mobile ? "1" : "0 1 auto" }}
                                >
                                    Sincronizar
                                </Button>
                        </div>
                    </div>
                </div>
                <Grid key={renderKey} className={classes.containerItens}>
                    <List fullWidth>
                        {categorias?.map((categoria, index) => (
                            <ListItem
                                className={classes.listItem}
                                key={categoria.id}
                                onDragOver={() => handleDragOver(index)}
                            >
                                <Categorias index={index} categoria={categoria} />
                            </ListItem>
                        ))}
                    </List>
                </Grid>
            </div>
            <Dialog
                open={openConfirmacaoSalvar99}
                onClose={handleCloseConfirmacaoSalvar99}
                maxWidth="xs"
            >
                <DialogTitle>
                    Salvar Cardápio <img src={logo99} alt="Logo 99" height={36} width={36} />
                </DialogTitle>
                <DialogContent style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
                    <Typography>Atenção!</Typography>
                    <Typography>
                        Você está prestes a atualizar o cardápio da 99Food. Essa alteração irá
                        sobrescrever o cardápio cadastrado na 99 Food pelo cardápio da Cliente Fiel.
                    </Typography>
                    <Typography>Deseja continuar?</Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseConfirmacaoSalvar99}>Fechar</Button>
                    <Button color="primary" variant="contained" onClick={salvarCardapio99}>
                        Salvar
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}
